import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { addToCalendar: "Agregar al calendario", downloadIcs: "Descargar .ics (Apple / Outlook)" },
  en: { addToCalendar: "Add to calendar", downloadIcs: "Download .ics (Apple / Outlook)" },
});
